/* eslint-disable prettier/prettier */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const host = window.location.host;

export const msalConfig = {
    auth: {
        clientId: "cbbf3230-f46b-473e-aba7-74a9778b7720",
        authority: "https://login.microsoftonline.com/aa7a0173-20d5-48f4-8d55-aec18e94230f",
        redirectUri: host.includes('app-extranet-frontend-extranet-homolog.azurewebsites.net') ?
                        "https://app-extranet-frontend-extranet-homolog.azurewebsites.net" :
                            (
                                host.includes('extranetfrontend.aethra.com.br') ?
                                    "https://extranetfrontend.aethra.com.br/" : (
                                        host.includes('extranet.aethra.com.br') ?
                                         "https://extranet.aethra.com.br/" : "http://localhost:3000/"
                                        )
                            ) ,
        postLogoutRedirectUri: host.includes('app-extranet-frontend-extranet-homolog.azurewebsites.net') ? 
                                    "https://app-extranet-frontend-extranet-homolog.azurewebsites.net" : 
                                        (
                                            host.includes('extranetfrontend.aethra.com.br') ? 
                                                "https://extranetfrontend.aethra.com.br/" : (
                                                    host.includes('extranet.aethra.com.br') ?
                                                        "https://extranet.aethra.com.br/" : "http://localhost:3000/"
                                                    )
                                        ),
        knownAuthorities: ["login.microsoftonline.com"],
      },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};
